export default __webpack_public_path__ + "assets/apple-touch-icon-29x29-e32a19e.png";